import script from "./GradeLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./GradeLayout.vue?vue&type=script&setup=true&lang=js"

import "./GradeLayout.vue?vue&type=style&index=0&id=5bd2cd53&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bd2cd53"]])

export default __exports__